var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg026CloudComputing1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.084,375.3c-7.843-7.779-20.506-7.727-28.284,0.116L275,432.685V236.5c0-11.046-8.954-20-20-20 c-11.046,0-20,8.954-20,20v194.168l-54.8-55.252c-7.778-7.841-20.441-7.895-28.284-0.116c-7.842,7.778-7.895,20.441-0.116,28.284 l61.654,62.162C224.809,477.195,239.919,483.5,256,483.5s31.191-6.305,42.547-17.754l61.653-62.162 C367.978,395.741,367.926,383.078,360.084,375.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462,178.146v-13.324C462,89.654,400.846,28.5,325.678,28.5c-32.732,0-64.381,11.776-89.115,33.16 c-16.363,14.146-29.025,31.881-37.093,51.591c-12.402-6.338-26.253-9.751-40.47-9.751c-49.075,0-89,39.925-89,89v18.188 C29.978,219.662,0,255.18,0,297.5c0,23.773,8.999,46.067,25.34,62.774C41.881,377.187,64.134,386.5,88,386.5h7 c11.046,0,20-8.954,20-20c0-11.046-8.954-20-20-20h-7c-26.916,0-48-21.523-48-49c0-27.019,22.361-49,49.846-49H90 c11.046,0,20-8.954,20-20v-36c0-27.019,21.981-49,49-49c14.036,0,27.427,6.052,36.741,16.604 c5.134,5.816,13.168,8.138,20.612,5.959c7.445-2.179,12.958-8.466,14.146-16.132c7.193-46.423,48.11-81.431,95.178-81.431 C378.79,68.5,422,111.71,422,164.822v24.598c0,7.4,4.087,14.196,10.624,17.666C456.912,219.977,472,245.041,472,272.5 c0,34.76-23.624,64.428-57.45,72.146c-10.769,2.458-17.506,13.18-15.049,23.948c2.458,10.77,13.181,17.51,23.948,15.05 c24.772-5.653,47.249-19.708,63.289-39.575C503.028,323.893,512,298.476,512,272.5C512,234.367,493.119,199.237,462,178.146z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg026CloudComputing1);
export default __webpack_public_path__ + "static/media/026-cloud-computing-1.c8ca074f43bd13aa0218e97e9cdde749.svg";
export { ForwardRef as ReactComponent };